import React from 'react';
import { Space } from 'antd';
import { useStakeholders } from '@hooks';

import { COPY_SPECIFIC, TAG_COLORS } from '@sonar-software/sonar-ts-constants';

function getDotBackgroundColor(groupId: string, index: number): string {
	if (groupId === 'detected-combo') {
		return '#FAFAFA';
	}

	return `${TAG_COLORS[ index % TAG_COLORS.length ]}19`;
}

function getDotBorderColor(groupId: string, index: number): string {
	if (groupId === 'detected-combo') {
		return '#D9D9D9';
	}

	return TAG_COLORS[ index % TAG_COLORS.length ];
}

export interface GroupLegendProps {
	groupIds: Array<string>;
}

export const GroupLegend: React.FC<GroupLegendProps> = ({ groupIds }) => {
	const stakeholders = useStakeholders();

	return (
		<Space
			align='start'
			size='small'
			wrap>
			{ groupIds.map((groupId, index) =>
				<div
					className='grouping'
					key={ groupId }>
					<span
						className='group-dot'
						style={ {
							backgroundColor: getDotBackgroundColor(groupId, index),
							borderColor: getDotBorderColor(groupId, index)
						} } />
					<span className='group-label'>
						{ stakeholders.find((stakeholder) =>
							`${stakeholder.stakeholderId}-combo` === groupId)?.name ??
										COPY_SPECIFIC.UNREVIEWED }
					</span>
				</div>) }
		</Space>
	);
};
